import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createBlock(_component_DatePicker, {
    firstDayOfWeek: 2,
    modelValue: _ctx.inputValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
    "min-date": _ctx.minDate,
    "max-date": _ctx.maxDate,
    ref: "datePickerRef",
    "onUpdate:fromPage": _ctx.handleFromPage,
    "is-expanded": "",
    locale: "en",
    masks: {
                weekdays: 'WW'
            },
    "available-dates": _ctx.availableDates,
    attributes: [{
                dot: false,       
                dates: new Date(),
            }],
    "is-required": true,
    class: _normalizeClass(["calendar", {'calendar--disabled': _ctx.disabled}])
  }, null, 8, ["modelValue", "min-date", "max-date", "onUpdate:fromPage", "available-dates", "attributes", "class"]))
}